<template>
  <PurchaseOrderAddDialog
    :value="value"
    mode="edit"
    :record="record"
    :buying-station-id="buyingStationId"
    @input="$emit('input', $event)"
    @save="$emit('save', $event)"
    @close="$emit('close')"
  />
</template>

<script>
import PurchaseOrderAddDialog from "./AddDialog.vue";

export default {
  name: "PurchaseOrderEditDialog",
  components: { PurchaseOrderAddDialog },
  props: {
    value: { type: Boolean, default: false },
    record: { type: Object, default: null },
    buyingStationId: { type: [Number, String], default: null },
  },
};
</script>
